import type { FormEvent } from "react";
import { Building2 } from "lucide-react";
import type { OrganizationDetail } from "../../account";

type OrganizationSettingsPageProps = {
  canAdmin: boolean;
  organization: OrganizationDetail["organization"];
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
};

export function OrganizationSettingsPage({
  canAdmin,
  organization,
  onSubmit,
}: OrganizationSettingsPageProps) {
  return (
    <section className="account-panel workspace-section">
      <div className="workspace-section-heading">
        <div>
          <span className="eyebrow">Asetukset</span>
          <h2>Organisaation perustiedot</h2>
          <p>Nimen tai Y-tunnuksen muutos palauttaa organisaation Platformin varmennukseen.</p>
        </div>
        <Building2 />
      </div>
      <form className="settings-form" onSubmit={onSubmit}>
        <label>
          Virallinen nimi
          <input
            name="name"
            defaultValue={organization.name}
            minLength={2}
            maxLength={200}
            required
            disabled={!canAdmin}
          />
        </label>
        <label>
          Y-tunnus
          <input
            name="businessId"
            defaultValue={organization.business_id ?? ""}
            pattern="[0-9]{7}-[0-9]"
            disabled={!canAdmin}
          />
        </label>
        <label>
          Yhteyssähköposti
          <input
            name="contactEmail"
            type="email"
            defaultValue={organization.contact_email ?? ""}
            required
            disabled={!canAdmin}
          />
        </label>
        {canAdmin && <button>Tallenna perustiedot</button>}
      </form>
      {!canAdmin && (
        <div className="workspace-readonly">Vain omistaja tai ylläpitäjä voi muuttaa perustietoja.</div>
      )}
    </section>
  );
}
